import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
 
import { CommonService } from '../../services/common.service';
import { PhotographerService } from '../../services/photographer.service';
import { PhotographerDashboardComponent } from './components/dashboard/photographer-dashboard.component';
import { GetHiredComponent } from './components/get-hired/get-hired.component';
import { PhotographerOrderInfoComponent } from './components/order-info/photographer-order-info.component';
import { PhotographerOrderListComponent } from './components/order-list/photographer-order-list.component';
import { PhotographerComponent } from './components/photographer.component';
import { ShootingListComponent } from './components/shooting-list/shooting-list.component';
import { SidebarBasketConfirmationComponent } from './components/sidebar-basket-confirmation/sidebar-basket-confirmation.component';
import { SidebarBasketComponent } from './components/sidebar-basket/sidebar-basket.component';
import { SharedModule } from '../../shared/shared.module';
import { PhotographerRouting } from './photographer.routing';
import { PhotographerOrderInfoAutoSortingComponent } from './components/order-info-auto-sorting/photographer-order-info-auto-sorting.component';
import { PhotographerOrderListAutoSortingComponent } from './components/order-list-auto-sorting/photographer-order-list-auto-sorting.component';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
   
    SharedModule,
    PhotographerRouting,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
  ],
  declarations: [
    PhotographerComponent,
    PhotographerDashboardComponent,
    GetHiredComponent,
    ShootingListComponent,
    PhotographerOrderListComponent,
    PhotographerOrderListAutoSortingComponent,
    SidebarBasketComponent,
    SidebarBasketConfirmationComponent,
    PhotographerOrderInfoComponent,
    PhotographerOrderInfoAutoSortingComponent
  ],
  exports: [PhotographerComponent],
  providers: [PhotographerService, CommonService]
})
export class PhotographerModule { }
